/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ZohoServiceDeskBudgetAlertDescriptionAttribute {
    actual_amount = 'actual_amount',
    budget_amount = 'budget_amount',
    budget_frequency = 'budget_frequency',
    budget_name = 'budget_name',
    budget_type = 'budget_type',
    configuration_type = 'configuration_type',
    created_at = 'created_at',
    currency = 'currency',
    project_name = 'project_name',
    service_accounts = 'service_accounts',
    threshold_percentage = 'threshold_percentage',
    updated_at = 'updated_at'
}
